import { extend } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
import app from 'flarum/forum/app';
import UserCard from 'flarum/forum/components/UserCard';
export default function addUserCardStats() {
  extend(UserCard.prototype, 'infoItems', function (items) {
    if (!this.attrs.user || !app.forum.attribute('ianm-follow-users.stats-on-profile')) return;
    const user = this.attrs.user;
    const followedUsersCount = user.followingCount();
    const followersUsersCount = user.followerCount();
    items.add('followers', m("div", {
      className: "FollowUsers--stats"
    }, m("span", null, m(Icon, {
      name: "fas fa-user-friends"
    }), m("span", {
      className: "FollowUsers--count"
    }, followedUsersCount, " "), ' ', app.translator.trans('ianm-follow-users.forum.followed', {
      count: followedUsersCount
    }), m("span", {
      className: "FollowUsers--count"
    }, followersUsersCount), ' ', app.translator.trans('ianm-follow-users.forum.followers', {
      count: followersUsersCount
    }))), 40);
  });
}